export default __webpack_public_path__ + "6ed92399b1600ba35d125d21c1598c9c.png";